// JavaScript Document


(function ( $ ) {

	// Modal window
	$.fn.modalBox = function() {
		var $this = this;
		var _htmlBg = "<div class='modal-bg'></div>"
		var _htmlClose = "<div class='close'><img src='http://www.ti.com/ww/en/assets/responsiveTemplate/img/modal-close.png' alt='close' title='close'></div>"
		var $modalWrap, _height, _ScrHeight, _CtsHeight, _ScrWidth;

		$(".modal-box").wrap( "<div class='modal-wrap'></div>");
		$(".modal-wrap").append(_htmlClose);

		$this.live('click', function(){
			var _id = $(this).attr("data-id");
			var _tab = $(this).attr("data-anchor");
				$modalWrap = $("#" + _id ).parent();
				_height = $modalWrap.outerHeight();
				_ScrHeight = $(window).height();
				_ScrWidth = $(window).width();

			$("body").append(_htmlBg);
			$(".modal-bg").fadeIn();

			setModalHeight();
			setWidthForIe8(_ScrWidth);
			$modalWrap.fadeIn();

			// set anchor link
			if(_tab != undefined) {
				var elem = $("#"+_tab);
				var offset = elem.offset().top - elem.closest(".modal-wrap").offset().top;
				$('.modal-box').animate({scrollTop: offset}, "fast");
			}
		});

		function modalFadeOut() {
			$(".modal-wrap:visible, .modal-bg:visible").fadeOut(function(){
				$(".modal-wrap").css("height","auto");
				$(".modal-bg").remove();
				$('.modal-box').scrollTop(0);
			});
		}

		function setModalHeight(){
			_height = $modalWrap.outerHeight();
			_ScrHeight = $(window).height();

			if(_height > _ScrHeight) {
				$modalWrap.height( _ScrHeight - 40 ).css("margin-top","-" + ((_ScrHeight - 40) / 2 ) + "px");
			} else {
				$modalWrap.css("margin-top","-" + _height/2 + "px")
			}
		}

		function setWidthForIe8(width){
			if($("body").hasClass("ie8") && width < 1100) {
				$modalWrap.addClass("ie8");
			} else {
				$modalWrap.removeClass("ie8");
			}
		}

		// Colse modal when click .close button
		$(".modal-wrap .close").click(function(){
			modalFadeOut();
		})

		// Close modal when click outside of box
		$(document).click(function(e) {
			if ($(".modal-wrap").is(':animated')) {
				return;
			}
			else if($(".modal-wrap").is(":visible")){
				var _Id = $(".modal-wrap:visible").find(".modal-box").attr("id");
				if (e.target.id != _Id && !$("#"+_Id).find(e.target).length) {
			        modalFadeOut();
			    }
			} else {
				return;
			}
		});

		var resizing;
		$(window).resize(function() {
	        clearTimeout(resizing); // call RESIZE event only once it's FINISHED ...
	        resizing = setTimeout(function() {
	            if($(".modal-wrap").is(":visible")) {
					setModalHeight();
					_ScrWidth = $(window).width();

					setWidthForIe8(_ScrWidth);
					var _CtsHeight = $modalWrap.find(".modal-box").css("height","auto").outerHeight();

					$modalWrap.find(".modal-box").css("height","100%");

					if ( _CtsHeight > _ScrHeight ) {
						$modalWrap.height( _ScrHeight - 40 ).css("margin-top","-" + ((_ScrHeight - 40) / 2 ) + "px");
					} else {
						$modalWrap.css("margin-top","-" + _CtsHeight/2 + "px")
						$modalWrap.css("height", _CtsHeight);
					}
				} else {
					return false
				}
	        }, 400);
	    });


	}


	// backtotop button
	$.fn.backToTop = function() {


		var $this = this;
		var _html = "<a class='btn-backToTop' name='&lid=en_us_back_to_top_btn'><span>TOP</span></a>"

		$this.append(_html);
		$(".btn-backToTop").click(function(){
			$('html, body').animate({ scrollTop: $("#ls-canvas").offset().top }, 'slow');
		})

		$(window).scroll(function() {
		    if ($(this).scrollTop()) {
		        $(".btn-backToTop").stop(true, true).fadeIn();
		    } else {
		        $(".btn-backToTop").stop(true, true).fadeOut();
		    }
		});
	}


}( jQuery ));



$(document).ready(function() {
	$(".btn-modal").modalBox();
	$(".enable-backToTop").backToTop();

});
